// Адресът за набиране на телефон (`tel:`) — чиста логика без React (тестове:
// telHref.test.ts). Ползва го `PhoneLink`.

/**
 * `tel:` с цифрите на телефона и водещия „+" — интервалите, тиретата и
 * скобите от свободния текст не трябват на набирането. Без нито една цифра
 * няма какво да се набере → `null`.
 */
export const telHref = (phone: string): string | null => {
  const dialable = phone.trim().replace(/(?!^\+)\D/g, "");
  return /\d/.test(dialable) ? `tel:${dialable}` : null;
};
